import { differenceInDays, differenceInHours, differenceInMinutes, differenceInMonths, differenceInWeeks, differenceInYears, fromUnixTime, getUnixTime, parseISO, } from 'date-fns';
export var getFormattedTimestamp = function (dataTimestamp, intl) {
    var nowTime = new Date();
    var postedTime = fromUnixTime(dataTimestamp);
    var minutes = differenceInMinutes(nowTime, postedTime);
    var hours = differenceInHours(nowTime, postedTime);
    var days = differenceInDays(nowTime, postedTime);
    var weeks = differenceInWeeks(nowTime, postedTime);
    var months = differenceInMonths(nowTime, postedTime);
    var years = differenceInYears(nowTime, postedTime);
    var timeAgo = '';
    var lessThanMinuteMessage = intl.formatMessage({
        id: 'shared.helpers.timestamp-formatter.less-than-minute',
        defaultMessage: 'less than a minute ago',
        description: 'A relative time message to let the user know something happened less than a minute ago.',
    });
    var formatOptions = { style: 'long' };
    if (minutes <= 0) {
        timeAgo = lessThanMinuteMessage;
    }
    else if (hours <= 0) {
        timeAgo = intl.formatRelativeTime(-minutes, 'minute', formatOptions);
    }
    else if (days <= 0) {
        timeAgo = intl.formatRelativeTime(-hours, 'hour', formatOptions);
    }
    else if (weeks <= 0) {
        timeAgo = intl.formatRelativeTime(-days, 'day', formatOptions);
    }
    else if (months <= 0) {
        timeAgo = intl.formatRelativeTime(-weeks, 'week', formatOptions);
    }
    else if (years <= 0) {
        timeAgo = intl.formatRelativeTime(-months, 'month', formatOptions);
    }
    else {
        timeAgo = intl.formatRelativeTime(-years, 'year', formatOptions);
    }
    return timeAgo;
};
export var getRelativeTimestamp = function (isoString, intl) {
    var parsedISO = parseISO(isoString);
    return getFormattedTimestamp(getUnixTime(parsedISO), intl);
};
export var currentYear = function (intl) {
    return intl.formatDate(new Date(), { year: 'numeric' });
};
//# sourceMappingURL=timestamp-formatter.js.map